import type {Logger} from 'core/logging/types';


export class CompositeLogger implements Logger {

    private readonly loggers: Logger[] = [];

    addLogger(logger: Logger): this {
        this.loggers.push(logger);
        return this;
    }

    trace(...data: any[]): void {
        this.loggers.forEach((logger) => logger.trace(...data));
    }

    debug(...data: any[]): void {
        this.loggers.forEach((logger) => logger.debug(...data));
    }

    info(...data: any[]): void {
        this.loggers.forEach((logger) => logger.info(...data));
    }

    warn(...data: any[]): void {
        this.loggers.forEach((logger) => logger.warn(...data));
    }

    error(...data: any[]): void {
        this.loggers.forEach((logger) => logger.error(...data));
    }
}